export const environment = {
    production: true,
    api: "https://ciot.maxmovi.guep.com.br/api/",
};
